import { NumberParam, StringParam, useQueryParams } from 'use-query-params'

import { GetLogisticParams } from 'redux/services/logistic/types'

import { LogisticStatus } from 'models/logistic'

export const useLogisticFilters = () => {
  const [query, setQuery] = useQueryParams(
    {
      limit: NumberParam,
      offset: NumberParam,
      search: StringParam,
      barcode: StringParam,
      start_date: StringParam,
      end_date: StringParam,
      status: StringParam,
      project: StringParam,
      card_type: StringParam,
    },
    {
      removeDefaultsFromUrl: true,
    },
  )

  const params: GetLogisticParams = {
    limit: Number(query.limit || 10),
    offset: Number(query.offset || 0),
    search: query.search || '',
    barcode: query.barcode || '',
    start_date: query.start_date || '',
    end_date: query.end_date || '',
    status: (query.status as LogisticStatus) || undefined,
    project: (query.project as LogisticStatus) || undefined,
    card_type: (query.card_type as LogisticStatus) || undefined,
  }

  const resetParams = () => {
    setQuery({}, 'replace')
  }

  const setParam = (key: keyof GetLogisticParams, value: string) => {
    setQuery({
      [key]: value || undefined,
    })
  }

  const deleteParam = (key: keyof GetLogisticParams) => {
    setQuery({
      [key]: undefined,
    })
  }

  return {
    params,
    setParam,
    deleteParam,
    resetParams,
  }
}
